/**
 * Web stand-in for `react-native-permissions`.
 *
 * Browsers grant capability per-API at call time (getUserMedia, clipboard,
 * notifications), so there is no separate permission step. Everything reports
 * as granted and the real prompt happens when the API is used.
 */
export const RESULTS = {
  UNAVAILABLE: 'unavailable',
  DENIED: 'denied',
  LIMITED: 'limited',
  GRANTED: 'granted',
  BLOCKED: 'blocked',
} as const;

export const PERMISSIONS = {ANDROID: {}, IOS: {}, WINDOWS: {}} as const;

export async function check(): Promise<string> {
  return RESULTS.GRANTED;
}

export async function request(): Promise<string> {
  return RESULTS.GRANTED;
}

export async function checkMultiple(permissions: string[]): Promise<Record<string, string>> {
  return permissions.reduce<Record<string, string>>((acc, p) => {
    acc[p] = RESULTS.GRANTED;
    return acc;
  }, {});
}

export async function requestMultiple(permissions: string[]): Promise<Record<string, string>> {
  return checkMultiple(permissions);
}

export async function openSettings(): Promise<void> {
  // No browser equivalent - site settings are owned by the browser chrome.
}

export default {RESULTS, PERMISSIONS, check, request, checkMultiple, requestMultiple, openSettings};
